import { tryOnScopeDispose } from "@vueuse/core";
import { ref, toValue, watch } from "vue";
import { createApiClient } from "#/shared/api/client";
import { hasRenderableAvailability } from "./useAddressAvailability";

const api = createApiClient({ parse: false });

export function useAddressAvailabilityFetch({ url, enabled = true }) {
  const availability = ref(null);
  let activeRequestController;

  watch(
    () => [toValue(url), Boolean(toValue(enabled))],
    ([nextUrl, isEnabled]) => {
      abortActiveRequest();
      availability.value = null;

      if (isEnabled && nextUrl) {
        fetchAvailability(nextUrl);
      }
    },
    { immediate: true },
  );

  tryOnScopeDispose(abortActiveRequest);

  async function fetchAvailability(path) {
    const controller = new AbortController();
    activeRequestController = controller;

    try {
      const data = await api.request("get", path, { signal: controller.signal });

      if (controller.signal.aborted) {
        return;
      }

      availability.value = hasRenderableAvailability(data) ? data : null;
    } catch {
      // Failed availability fetches should not replace a previously rendered badge with an error state.
    } finally {
      if (activeRequestController === controller) {
        activeRequestController = undefined;
      }
    }
  }

  function abortActiveRequest() {
    activeRequestController?.abort();
    activeRequestController = undefined;
  }

  return { availability };
}
